export default "__VITE_ASSET__CGg4MttJ__"